module.exports = __webpack_public_path__ + "static/media/banner_bg copy.5be01756.jpg";